import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "title", "submenu", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `commercial--marketing--events--admissions--dashboard`
  }

  doAdmissionGrid() {
    var html = `<div class="row">
                  <div class="col-8 pr-2" data-${this.controllerName}-target="list" data-controller="commercial--marketing--events--admissions--list">attendee</div>
                  <div class="col-4 pl-2" data-${this.controllerName}-target="view" data-controller="commercial--marketing--events--admissions--show
                                                                                                     commercial--marketing--events--admissions--save
                                                                                                     commercial--sales--leads--entities--save">form</div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`commercial--marketing--events--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`commercial--marketing--events--admissions--list`).permission = `commercial_event_admissions`
      controller.getControllerByIdentifier(`commercial--marketing--events--admissions--show`).permission = `commercial_event_admissions`
      controller.getControllerByIdentifier(`commercial--marketing--events--admissions--save`).permission = `commercial_event_admissions`
      controller.getControllerByIdentifier(`commercial--marketing--events--admissions--list`).doIndexListHtml()
      controller.getControllerByIdentifier(`commercial--marketing--events--admissions--show`).doViewHtml()

      controller.getControllerByIdentifier(`commercial--sales--leads--entities--save`).gridElement = controller.viewTarget
      controller.getControllerByIdentifier(`commercial--sales--leads--entities--save`).permission = `commercial_event_admissions`
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    this.getControllerByIdentifier("app--helpers--console").console(results)
    return results
  }

  // controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(9, 6))
  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
